import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [
    "recurringFrequency",
    "businessJustification",
    "requestTypeOther",
    "requestedFormatOther"
  ]

  connect() {
    this.toggleRecurring()
    this.toggleJustification()
    this.toggleRequestTypeOther()
    this.toggleRequestedFormatOther()
  }

  toggleRecurring() {
    if (!this.hasRecurringFrequencyTarget) return
    const selected = this.element.querySelector('input[name="data_management_request[request_frequency]"]:checked')
    const show = selected && selected.value === "recurring"
    this.recurringFrequencyTarget.classList.toggle("hidden", !show)
    this.recurringFrequencyTarget.querySelectorAll("select, input").forEach((el) => {
      el.disabled = !show
      if (!show && el.tagName === "SELECT") el.value = ""
    })
  }

  toggleJustification() {
    if (!this.hasBusinessJustificationTarget) return
    const selected = this.element.querySelector('input[name="data_management_request[priority]"]:checked')
    const show = selected && selected.value === "critical"
    this.businessJustificationTarget.classList.toggle("hidden", !show)
    const field = this.businessJustificationTarget.querySelector("textarea")
    if (field) {
      field.required = !!show
      if (!show) field.value = ""
    }
  }

  toggleRequestTypeOther() {
    if (!this.hasRequestTypeOtherTarget) return
    const selected = this.element.querySelector('input[name="data_management_request[request_type]"]:checked')
    const show = selected && selected.value === "other"
    this.requestTypeOtherTarget.classList.toggle("hidden", !show)
    const field = this.requestTypeOtherTarget.querySelector("input, textarea")
    if (field) {
      field.required = !!show
      if (!show) field.value = ""
    }
  }

  toggleRequestedFormatOther() {
    if (!this.hasRequestedFormatOtherTarget) return
    const selected = this.element.querySelector('input[name="data_management_request[requested_format]"]:checked')
    const show = selected && selected.value === "other"
    this.requestedFormatOtherTarget.classList.toggle("hidden", !show)
    const field = this.requestedFormatOtherTarget.querySelector("input, textarea")
    if (field) {
      field.required = !!show
      if (!show) field.value = ""
    }
  }
}
